import React, { useContext, useState } from "react";
import { SiteContext } from "../App";
import "../styles/Page1.scss";

const Page1 = () => {
  const { setCurrentPage } = useContext(SiteContext);
  return (
    <div className="home-page-container">
      <img src="/images/background1.jpg" alt="bkg" className="background" />
      <img
        src="/images/button_get.png"
        alt="button"
        className="button"
        onClick={() => {
          setCurrentPage(2);
        }}
      />
    </div>
  );
};

export default Page1;
